import { Utils } from "./utils";

enum StorageKeys {
  DashFilterTagId = "dfti",
  DashboardTaskSelTab = "dtst",
  DashboardTaskRecuranceMem = "dtrm",
  TaskDashFilterType = "tdft",
  TaskDashIncludeTaskRecurance = "tditr",
  TaskDashRecuranceDivExpand = "tdrde",
  TaskDashDivMode = "tddm",
  TaskDashDivMemRsp = "tddm_rsp",
  TaskDashDivMemAsg = "tddm_asg",
  TaskDashDivMemReq = "tddm_req",
  TaskDashDateRange = "tddr",
  TaskDashNameFilter = "tdnf",
}
export enum DashTaskTabs { ALL_TASK = 1, RECURANCE_TASK = 2 }

export class StorageUtils {
  private static Get(key: StorageKeys, def: string | null = null) {
    return localStorage.getItem(key.toString()) ?? def;
  }
  private static Set(key: StorageKeys, val: string | null) {
    if (val == null) {
      localStorage.removeItem(key.toString());
    } else {
      localStorage.setItem(key.toString(), val);
    }
  }

  static get DashboardFilterTagId() {
    const val = Utils.ToNumber(this.Get(StorageKeys.DashFilterTagId), null) ?? null;
    // console.log('DashboardFilterTagId Get:', val);
    return val;
  }
  static set DashboardFilterTagId(val: number | null) {
    // console.log('DashboardFilterTagId Set:', val);
    this.Set(StorageKeys.DashFilterTagId, val ? val.toString() : null);
  }


  static get DashboardTaskSelTab() {
    const val = Utils.ToNumber(this.Get(StorageKeys.DashboardTaskSelTab), DashTaskTabs.ALL_TASK)! as DashTaskTabs;
    // console.log('DashboardFilterTagId Get:', val);
    return val;
  }
  static set DashboardTaskSelTab(val: DashTaskTabs) {
    // console.log('DashboardFilterTagId Set:', val);
    this.Set(StorageKeys.DashboardTaskSelTab, val.toString());
  }

  static get DashboardTaskRecuranceMem() {
    const val = this.Get(StorageKeys.DashboardTaskRecuranceMem);
    return val;
  }
  static set DashboardTaskRecuranceMem(val: any) {
    this.Set(StorageKeys.DashboardTaskRecuranceMem, val.toString());
  }

  static get TaskDashFilterType() {
    const val = this.Get(StorageKeys.TaskDashFilterType);
    return val;
  }
  static set TaskDashFilterType(val: any) {
    this.Set(StorageKeys.TaskDashFilterType, val);
  }

  static get TaskDashIncludeTaskRecurance() {
    const val = this.Get(StorageKeys.TaskDashIncludeTaskRecurance);
    return val == "1";
  }
  static set TaskDashIncludeTaskRecurance(val: boolean) {
    this.Set(StorageKeys.TaskDashIncludeTaskRecurance, val ? "1" : "0");
  }

  static get TaskDashRecuranceDivExpand() {
    const val = this.Get(StorageKeys.TaskDashRecuranceDivExpand);
    return val;
  }
  static set TaskDashRecuranceDivExpand(val: string | null) {
    this.Set(StorageKeys.TaskDashRecuranceDivExpand, val);
  }

  static get TaskDashDivMode(): "DIV_RSP" | "DIV_ASG" | "DIV_REQ" {
    const val = this.Get(StorageKeys.TaskDashDivMode, "DIV_RSP");
    return val as "DIV_RSP" | "DIV_ASG" | "DIV_REQ";
  }
  static set TaskDashDivMode(val: "DIV_RSP" | "DIV_ASG" | "DIV_REQ") {
    this.Set(StorageKeys.TaskDashDivMode, val);
  }

  static get TaskDashDivMemRsp() {
    const val = this.Get(StorageKeys.TaskDashDivMemRsp);
    return val;
  }
  static set TaskDashDivMemRsp(val: string | null) {
    this.Set(StorageKeys.TaskDashDivMemRsp, val);
  }

  static get TaskDashDivMemAsg() {
    const val = this.Get(StorageKeys.TaskDashDivMemAsg);
    return val;
  }
  static set TaskDashDivMemAsg(val: string | null) {
    this.Set(StorageKeys.TaskDashDivMemAsg, val);
  }

  static get TaskDashDivMemReq() {
    const val = this.Get(StorageKeys.TaskDashDivMemReq);
    return val;
  }
  static set TaskDashDivMemReq(val: string | null) {
    this.Set(StorageKeys.TaskDashDivMemReq, val);
  }

  // preset name ("YTD" | "THIS_WEEK" | "PREV_WEEK" | "THIS_MONTH" | "PREV_MONTH") or "CUSTOM|<ms>|<ms>" - preset is kept by name so it stays relative to today
  static get TaskDashDateRange() {
    return this.Get(StorageKeys.TaskDashDateRange);
  }
  static set TaskDashDateRange(val: string | null) {
    this.Set(StorageKeys.TaskDashDateRange, val);
  }

  static get TaskDashNameFilter(): string {
    return this.Get(StorageKeys.TaskDashNameFilter) ?? "";
  }
  static set TaskDashNameFilter(val: string | null) {
    this.Set(StorageKeys.TaskDashNameFilter, val ? val : null);
  }


}

// export { StorageUtils }